<template>
  <div class="page-container">
    <md-app md-waterfall md-mode="fixed">
      <md-app-toolbar class="md-primary menu-toolbar">
        <md-button class="md-icon-button align-right white-button" @click="menuVisible = !menuVisible">
          Menú
        </md-button>
        <span class="md-title"><img class="logo" src="../../public/pbb.png" alt="PBB"></span>
        <span class="small-text">Las imágenes contenidas en esta página son de carácter ilustrativo. No comprometen a los desarrolladores a nivel de especificación o diseño.</span>
      </md-app-toolbar>

      <md-app-drawer :md-active.sync="menuVisible" class="menu-drawer">
        <md-toolbar class="menu-title menu-toolbar" md-elevation="0" >
          <md-button class="md-icon-button align-right" @click="menuVisible = !menuVisible">
            <md-icon class="white-icon">clear</md-icon>
          </md-button>
          <span class="md-title"><img class="logo" src="../../public/pbb.png" alt="PBB"></span>
          <span class="small-text">Las imágenes contenidas en esta página son de carácter ilustrativo. No comprometen a los desarrolladores a nivel de especificación o diseño.</span>
        </md-toolbar>

        <md-list>

          <md-list-item 
            v-for="item in mdList"
            :key="item.source"
            @click="menuItemClick(`https://kuula.co/share/${item.url}`, item.source)"
            class="menu-item"
            :class="item.style.bg"
          >
              <span 
                class="md-list-item-text"
                :class="item.style.color"
              >
                <p :style="selectedItem == item.source ? 'text-decoration: underline' : ''">
                  {{item.name}}
                </p>
              </span>
          </md-list-item>

        </md-list>
      </md-app-drawer>
    </md-app>
  </div>
</template>

<script>
export default {
  name: 'Menu',
  props: {
    mdList: Array
  },
  data: () => ({
    menuVisible: false,
    selectedItem: 11
  }),
  methods: {
    menuItemClick(newSource, itemToSelect) {
      this.menuVisible = !this.menuVisible;
      this.selectedItem = itemToSelect;
      this.$emit("tourChanged", newSource);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@font-face {
  font-family: 'Landmark Regular';
  src: url('../../public/Landmark-Regular.otf');
}

.small-text {
  font-size: 10px;
  width: 300px;
  line-height: 12px;
  font-weight: 100;
  text-transform: uppercase;
}

.md-app {
    max-height: 400px;
}

.md-drawer {
  width: 100%;
  max-width: 100%;
}

.menu-drawer {
  position: fixed;
  height: 100%;
  background-color: transparent;
}

.align-right {
  left: calc(100% - 50px);
}

.md-title {
  position: relative;
  left: -50px;
  margin-left: 4px !important;
}

.menu-title {
  font-weight: 400;
  letter-spacing: .02em;
  font-size: 20px;
  padding-left: 16px;
}

.menu-toolbar {
  background-color: #1B3018;
  color: #F6FFEA;
}

.white-icon {
  color: #F6FFEA;
  font-size: 2.5em !important;
  font-size: 2em;
}

.white-button {
  font-family: 'Landmark Regular';
  font-size: 1.6em;
  color: #F6FFEA;
  font-weight: 300;
  width: 60px;
  left: calc(100% - 73px) !important;
  top: 1.5px !important;
}

.menu-item-text {
  position: relative;
  height: 100%;
  width: 100%;
  font-size: 2em;
  color: #F6FFEA;
  /* font-family: 'Open Sans', sans-serif;
  font-weight: 300; */
  font-family: 'Landmark Regular';
  display: contents;
}

.menu-item-text2 {
    &:extend(.menu-item-text);
    color: #1b3018;
}

.menu-item-text:hover, .menu-item-text2:hover {
  text-decoration: underline;
}


.menu-item {
  opacity: 0.85;
  filter: alpha(opacity=50); /* For IE8 and earlier */
  height: 10%;
  box-sizing: border-box;
  border-bottom: 1px solid #F6FFEA;
  font-size: 2em;
  color: #F6FFEA;
  font-family: 'Landmark Regular';
}

.green-1 {
  background-color: #2E7A37;
}

.purple-1 {
  background-color: #330526;
}

.purple-2 {
  background-color: #660443;
}

.purple-3 {
  background-color: #813365;
}

.yellow-1 {
  background-color: #f4d03b;
}

.orange-1 {
  background-color: #F7572D;
}

.md-list {
  padding: 0px !important;
  height: 100%;
  height: calc(100% - 64px);
}

.logo {
  height: 20px;
}

.md-list-item-container {
  height: 100%;
}


@media only screen and (min-width: 1281px) {
  .menu-item-text {
    font-size: 2.2em;
  }
}

@media only screen and (max-width: 960px) {
  .md-list {
    height: calc(100% - 48px);
  }

  .white-button {
    top: 1.5px !important;
  }
}

@media only screen and (max-width: 599px) {
  .menu-item-text {
    font-size: 1.3em;
  }

  .md-list {
    height: calc(100% - 56px);
  }

  .white-button {
    top: 2px !important;
  }
}

@media only screen and (max-width: 450px) {
  .small-text {
    margin-bottom: 10px;
  }
}
</style>
